// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xt1_WDfw3pmm6e {
  margin-left: -12px;
  margin-right: -12px;
  position: relative;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-image: linear-gradient(to bottom, var(--ds-background-brand-bold, #0c66e4) 0%, var(--ds-background-brand-bold, #0c66e4) 100%);
  background-repeat: no-repeat;
  background-size: 100% 82px;
  box-sizing: content-box;
  padding: 24px 12px 8px 14px;
  display: flex;
  align-items: flex-start;
}
.pJW8DUFHgh_qNL {
  margin-left: 8px;
  margin-top: 8px;
  min-width: 0;
  flex: 1;
}
.VtV5gSQpGjYPuf {
  color: var(--ds-text-inverse, #ffffff);
  font-size: 16px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.VtV5gSQpGjYPuf::selection {
  background: var(--ds-background-inverse-subtle, #00000029);
}
.CfwvHjigylLnTt {
  background-color: var(--ds-background-accent-blue-subtle, hsla(0, 0%, 100%, 0.3));
  border-radius: 3px;
  height: 16px;
  width: 75%;
}
.tEKZGoudPZ6X5e {
  color: var(--ds-text-inverse, #ffffff);
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
}
.tEKZGoudPZ6X5e::selection {
  background: var(--ds-background-inverse-subtle, #00000029);
}
.psxQTZBwNirnUM {
  background-color: var(--ds-background-accent-blue-subtle, hsla(0, 0%, 100%, 0.3));
  border-radius: 3px;
  height: 12px;
  width: 75%;
  margin-left: 4px;
}
.FEKasnw3f3XYG1 {
  min-width: 88px;
  min-height: 88px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardTop": `Xt1_WDfw3pmm6e`,
	"profileInfo": `pJW8DUFHgh_qNL`,
	"fullName": `VtV5gSQpGjYPuf`,
	"fullNameSkeleton": `CfwvHjigylLnTt`,
	"atName": `tEKZGoudPZ6X5e`,
	"atNameSkeleton": `psxQTZBwNirnUM`,
	"avatar": `FEKasnw3f3XYG1`
};
export default ___CSS_LOADER_EXPORT___;
